import { dispatch } from 'app/store';
import backend from 'app/backend';
import { EmailAddressChangeRequest } from 'types/emailAddressChangeRequest';
export default function ValidateEmailAddressChangeRequest(
  LoginEmail?: string | null,
  AuthorizationToken?: string | null,
) {
  dispatch({
    type: 'VALIDATE_EMAIL_ADDRESS_CHANGE_REQUEST_START',
  });
  backend
    .dispatch<EmailAddressChangeRequest>('ValidateEmailAddressChangeRequest', {
      LoginEmail,
      AuthorizationToken,
    })
    .then((response) => {
      if (!response.Success) {
        dispatch({
          type: 'VALIDATE_EMAIL_ADDRESS_CHANGE_REQUEST_FAIL',
          message: response.Error,
        });
        return;
      }
      dispatch({
        type: 'VALIDATE_EMAIL_ADDRESS_CHANGE_REQUEST_SUCCESS',
        loginEmail: LoginEmail,
        emailAddressChangeRequest: response.Result,
      });
    });
}
